import React, { Component } from 'react';
import { View, Image, TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { Icon, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import Badge from '../../Dashboard/Tray/Components/Badge/Badge';
import FrameworkTestKeys from '../../FrameworkTestKeys';
import Images from '../../Themes/Images';

import styles from './SubTrayItemView.Styles';

class SubTrayItemView extends Component {
  constructor(props) {
    super(props);
  }
  renderBadge = (width, height) => {
    const { isRecommended, badgeText, badgeStyle, notification, withLock } = this.props;
    return notification && !withLock ? (
      <Badge text={notification.toString()} containerStyle={styles.badgeStyle(width)} />
    ) : (
      <View style={styles.badgeContainer} testID={FrameworkTestKeys.subTrayItemViewBadgeView}>
        {
          // DEPRECATEME: since [Release 22]
          isRecommended &&
            console.warn(
              'isRecommended Prop is deprecated and will no longer be supported in future releases, Please use "badgeText" instead. \n for more details visit https://github.vodafone.com/pages/VFGroup-MyVodafone-OnePlatform/Documentation/React%20Native/Framework/Tray/',
            )
        }
        {(isRecommended || badgeText) && (
          <View
            style={[styles.recommendedBadageContainer(height), badgeStyle]}
            testID={FrameworkTestKeys.subTrayItemViewBadgeRecommendedView}
          >
            <VFText
              i18nKey={badgeText || 'device_upgrade_recommended_title'}
              style={styles.textStyle}
              testKey={FrameworkTestKeys.subTrayItemViewBadgeRecommendedText}
            />
          </View>
        )}
      </View>
    );
  };
  render() {
    const {
      index,
      notification,
      onPress,
      image,
      itemSubtitleWithBadge,
      trayPlaceHolders,
      itemSubTitle,
      itemTitle,
      itemTitleStyle,
      itemDescription,
      cardDescriptionSpace,
      theme,
      accessibilityID,
      imageProps,
      subTitleProps,
      containerViewStyle,
      withLock,
      titleNumberOfLines,
      subTitleNumberOfLines,
      descriptionNumberOfLines,
    } = this.props;
    const hasNotification = notification > 0;

    const localSubTitleKey = withLock
      ? itemSubTitle
      : hasNotification
      ? itemSubtitleWithBadge
      : itemSubTitle;

    const width =
      hasNotification && notification.toString().length > 1
        ? (notification.toString().length + 1) * 8
        : 20;
    const height = cardDescriptionSpace ?? 142;
    const accessibilityLabel = `${accessibilityID}${index + 1}`;
    return (
      <TouchableWithoutFeedback
        accessibilityLabel={accessibilityLabel}
        testID={accessibilityLabel}
        onPress={onPress}
        accessible={false}
      >
        <View
          style={[styles.containerStyle(theme), containerViewStyle]}
          testID={FrameworkTestKeys.SubTrayItemViewInnerContainer}
        >
          {withLock && (
            <View
              style={styles.lockContainer(theme)}
              testID={FrameworkTestKeys.subTrayItemViewLockView}
            >
              <Icon
                name={Images.icSecurityRed}
                size={19}
                testID={FrameworkTestKeys.subTrayItemViewLockIcon}
              />
            </View>
          )}
          {this.renderBadge(width, height)}
          <View
            style={styles.textContainerStyle(theme, withLock)}
            testID={FrameworkTestKeys.subTrayItemViewLockTextContainer}
          >
            <VFText
              testKey={FrameworkTestKeys.SubTrayItemViewTitle}
              i18nKey={itemTitle}
              placeHolders={trayPlaceHolders && trayPlaceHolders[itemTitle]}
              style={[styles.titleStyle(theme), itemTitleStyle]}
              numberOfLines={titleNumberOfLines}
            />

            <VFText
              testKey={FrameworkTestKeys.SubTrayItemViewSubTitle}
              i18nKey={localSubTitleKey ?? ''}
              placeHolders={trayPlaceHolders && trayPlaceHolders[localSubTitleKey]}
              {...subTitleProps}
              style={[styles.subTitleStyle(theme), subTitleProps.style]}
              numberOfLines={subTitleNumberOfLines}
            />
            {itemDescription && (
              <VFText
                testKey={FrameworkTestKeys.SubTrayItemViewDescription}
                i18nKey={itemDescription}
                placeHolders={trayPlaceHolders && trayPlaceHolders[itemDescription]}
                style={[styles.subTitleStyle(theme), styles.descriptionStyle]}
                numberOfLines={descriptionNumberOfLines}
              />
            )}
          </View>
          <Image
            {...imageProps}
            testID={FrameworkTestKeys.SubTrayItemViewIcon}
            source={image}
            style={[styles.imageStyle, imageProps.style]}
          />
        </View>
      </TouchableWithoutFeedback>
    );
  }
}

SubTrayItemView.defaultProps = {
  onPress: () => {},
  notification: 0,
  theme: LightThemeColors,
  imageProps: {},
  subTitleProps: {},
  withLock: false,
  isRecommended: false,
  subTitleNumberOfLines: 2,
};

SubTrayItemView.propTypes = {
  itemTitle: PropTypes.string.isRequired,
  itemTitleStyle: TextPropTypes.style,
  itemSubTitle: PropTypes.string.isRequired,
  itemSubtitleWithBadge: PropTypes.string,
  image: PropTypes.any.isRequired,
  notification: PropTypes.number,
  key: PropTypes.number,
  onPress: PropTypes.func,
  theme: PropTypes.object,
  trayPlaceHolders: PropTypes.object,
  index: PropTypes.number,
  accessibilityID: PropTypes.string,
  imageProps: PropTypes.object,
  subTitleProps: PropTypes.object,
  containerViewStyle: ViewPropTypes.style,
  withLock: PropTypes.bool,
  isRecommended: PropTypes.bool,
  badgeText: PropTypes.string,
  badgeStyle: ViewPropTypes.style,
  itemDescription: PropTypes.string,
  cardDescriptionSpace: PropTypes.number,
  titleNumberOfLines: PropTypes.number,
  subTitleNumberOfLines: PropTypes.number,
  descriptionNumberOfLines: PropTypes.number,
};

export default withTheme(SubTrayItemView);
